export const firebaseConfig = {
    apiKey: "AIzaSyDPcZrlDe0sjZ0suIBa1OpOy0buv1rdg3A",
    authDomain: "distributely-qa.firebaseapp.com",
    projectId: "distributely-qa",
    storageBucket: "distributely-qa.firebasestorage.app",
    messagingSenderId: "1041856455064",
    appId: "1:1041856455064:web:0f93d72f5b0b68527e4bed"
  };